import { Application } from "stimulus"
import { definitionsFromContext } from "stimulus/webpack-helpers"
import "./assets/polyfills";
import "./assets/translate";
import "./assets/tp-config";
import './alpinejs';

// Stimulus initialisieren
const application = Application.start()
const context = require.context("./controllers", true, /\.js$/)
application.load(definitionsFromContext(context))

/**
 * In der Entwicklungsumgebung die Stimulus-Anwendung öffentlich zugänglich machen.
 * Mittels window.stimulusjs.getController($0) kann dann die Controller-Instanz des aktuell
 * ausgewählten Elements geholt werden.
 *
 * process.env.NODE_ENV steht nur zur Compile-Zeit zur Verfügung.
 */
if (process.env.NODE_ENV === 'development') {
    application.getController = function(element) {
        return application.controllers.find(controller => controller.element === element);
    }
    window.stimulusjs = application;
    document.body.classList.add('development');
}
